const {
  getOauthThirdParty,
  bindOauthAccount,
  getOauthToken,
  checkVerifyCode
} = require('@/api/oauth')

const state = {
  oauthThirdParty: []
}

const mutations = {
  setOauthThirdParty(state, data) {
    state.oauthThirdParty = data
  }
}

const actions = {
  async fetchOauthThirdParty(
    { commit, state },
    { force, params } = { force: false }
  ) {
    if (!force && state.oauthThirdParty.length > 0) {
      return state.oauthThirdParty
    }
    const data = await getOauthThirdParty(params)
    commit('setOauthThirdParty', data)
    return data
  },
  bindOauthAccount(_, body) {
    return bindOauthAccount(body)
  },
  fetchOauthToken(_, verifyCode) {
    return getOauthToken(verifyCode)
  },
  checkVerifyCode(_, verifyCode) {
    return checkVerifyCode(verifyCode)
  }
}

const oauthModule = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default oauthModule
